import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useQuery } from '@apollo/client/react';
import ServerError from '../error/ServerError';
import Loading from '../../components/shared/Loading';

import {
  Avatar,
  Box,
  Card,
  CardHeader,
  CardContent,
  Typography,
} from '@mui/material';
import { GET_WORKOUT_SESSIONS } from '../../graphql/workout_session';

export default function WorkoutAnalytics({ workout }) {
  const input = { workoutId: workout?._id };
  const { loading, error, data } = useQuery(GET_WORKOUT_SESSIONS, {
    variables: { input },
  });

  if (error) return <ServerError message="Failed to load" />;
  if (loading || !data?.workoutSessions) return <Loading />;
  if (!workout) {
    return <ServerError message="Failed to load" />;
  }
  const workoutSessions = data?.workoutSessions;

  return (
    <Box>
      <Typography variant="h1">{workout.completedCount}</Typography>
      <br />
      <Typography variant="caption">Completed</Typography>
      <br />
      <br />

      <Typography variant="h3" gutterBottom>
        Recent Completed Sessions
      </Typography>
      <Box>
        {workoutSessions.length === 0 && (
          <Typography variant="caption" gutterBottom>
            None completed.
          </Typography>
        )}
        {workoutSessions.map((workoutSession) => {
          return (
            <Card key={workoutSession._id} style={{ marginBottom: 16 }}>
              <CardHeader
                avatar={
                  <Avatar
                    alt="Person"
                    component={RouterLink}
                    src={workoutSession.user.avatarUrl}
                    to={`/trainer/users/${workoutSession.user._id}`}
                  />
                }
                subheader={
                  <Box display="flex" alignItems="center">
                    <Typography variant="caption" color="textSecondary">
                      <RouterLink
                        to={`/trainer/users/${workoutSession.user._id}`}
                      >
                        {workoutSession.user.name}
                      </RouterLink>{' '}
                      completed on {workoutSession.completedAt}
                    </Typography>
                  </Box>
                }
                title={
                  <Typography color="textPrimary" variant="h6">
                    <RouterLink
                      to={`/trainer/workout_sessions/${workoutSession._id}`}
                    >
                      {workoutSession.title}
                    </RouterLink>
                  </Typography>
                }
              />
              <CardContent>
                <Typography component="div" variant="body1" color="textPrimary">
                  <p>{workoutSession.notes}</p>
                  {workoutSession.photoUrl && (
                    <img
                      src={workoutSession.photoUrl}
                      alt={workoutSession.title}
                    />
                  )}
                  <RouterLink
                    to={`/trainer/workout_sessions/${workoutSession._id}`}
                  >
                    See More
                  </RouterLink>
                </Typography>
              </CardContent>
            </Card>
          );
        })}
      </Box>
    </Box>
  );
}
